const ar = {
  welcomeMessage: 'مرحباً بك ',
  home: 'الرئيسية',
  dashboard: 'لوحة المعلومات',
  eServices: 'الخدمات الالكترونية',
  appointments: 'المواعيد',
  appointmentDetails: 'تفاصيل الموعد',
  servieDetails: 'تفاصيل الخدمة',
  appointmentCard: 'بطاقة موعد',
  requestNewAppointment: 'حجز موعد جديد',
  newRequest: 'طلب جديد',
  instructions: 'تعليمات',
  newest: 'الأحدث',
  oldest: 'الاقدم',
  sortAs: 'ترتيب حسب',
  requestAppointmentForensicFacilities: 'حجز موعد زيارة مرفق عدلي',
  appointmentForensicFacilities: 'موعد زيارة مرفق عدلي',
  bookEndorsement: 'أتعهد بأني قرأت كافة التعليمات الخاصة لحجز موعد',
  atTime: 'الساعة',
  continue: 'متابعة',
  cancel: 'إلغاء',
  confirm: 'تأكيد',
  ok: 'تأكيد',
  reset: 'اعادة ضبط',
  back: 'تراجع',
  moveBack: 'الرجوع',
  actions: 'الإجراءات',
  warning: 'تنبيه',
  bookAppointment: 'حجز موعد',
  addToCalendar: 'إضافة للتقويم',
  procedures: 'الإجراءات',
  cancelbookAppointment: 'إلغاء إلغاء الموعد',
  cancelbookAppointmentSuccess: 'تم حذف الموعد بنجاح',
  cancelbookAppointmentRequestSuccess: 'طلب الموعد غير موجود',
  cancelbookAppointmentNotFound: 'الموعد غير موجود',
  cancelbookAppointmentRequestNotFound: 'تم حذف طلب الموعد بنجاح',
  cancelbookAppointmentBadRequest: 'حدث خطأ بإرسال رقم الهوية',
  requestDetails: 'وصف الخدمة',

  underStudying: 'تحت الدراسة',
  existing: 'قائم',
  rejectionReasons: 'اسباب الرفض',

  pending: 'تحت الدراسة',
  canceled: 'ملغي',
  rejected: 'مرفوض',
  active: 'قائم',

  congratulations: 'تهانينا!',
  successfullyAdded:
    'لقد تم استقبال طلبكم لحجز موعد جديد لزيارة المرافق العدلية سيتم إشعاركم عن طريق رسالة نصية في حال قبول أو رفض طلبكم علماً بأنه سيتم حجز أقرب موعد متاح عند الموافقة على طلبكم',

  confirmNewRequest: 'تأكيد حجز الموعد',
  willBookEarlist: 'سيتم حجز أقرب موعد متاح',
  confrimRequest: 'تأكيد الحجز',

  areYouSureToCancelAppointment: 'هل أنت متأكد من إلغاء الموعد؟',
  confirmCancelAppointment: 'تأكيد إلغاء الموعد',

  areYouSureToCancelRequest: 'هل أنت متأكد من إلغاء الطلب؟',
  confirmCancelRequest: 'تأكيد إلغاء الطلب',

  appointmentStatus: 'حالة الموعد',
  appointmentCategory: 'فئة الموعد',
  service: 'الخدمة',
  place: 'المكان',
  dateAndTime: 'التاريخ والوقت',
  date: 'التاريخ',
  time: 'الوقت',
  cancelAppointment: 'إلغاء الموعد',
  appointmentNumber: 'رقم الموعد',
  searchPlaceholder: 'ابحث برقم الموعد أو المكان',
  filterByStatus: 'اختر حالة الموعد',
  gregorian: 'ميلادي',
  hijri: 'هجري',
  filterWithDate: 'اختر الفترة الزمنية',
  dateOfBirth: 'تاريخ الميلاد',
  birthDatePlaceholder: 'اختر تاريخ الميلاد',
  filterAppointmentsWith: 'البحث عن موعد بواسطة ({text})',
  fetchingData: 'جاري تحميل البيانات ...',
  noSearchResultsFor: 'لا توجد نتائج بحث تطابق ',
  noAppointmentsFound: 'لا توجد مواعيد متاحة',
  noTimeAvailableMsg: 'لا يوجد وقت متاح الرجاء إختيار يوم أخر',

  inputDateRange: 'يرجى ادخال فترة زمنية',
  availableTime: 'الوقت المتاح',
  appointmentPlace: 'مكان الموعد',
  locationDetails: 'تفاصيل الموقع',
  serviceDetails: 'تفاصيل الخدمة',
  nextText: 'التالي',
  cancelText: 'إلغاء',
  cancelRequestConfirmation: 'هل انت متأكد من إلغاء الطلب؟',
  cancelRequestConfirmationText:
    'بتأكيد الإلغاء لن يتم حفظ البيانات التي ادخلتها',
  cancelRequest: 'إلغاء الطلب',
  retreat: 'تراجع',
  prevText: 'السابق',
  requestReview: 'معاينة الطلب',
  region: 'المنطقة',
  department: 'القسم/الدائرة',
  site: 'مكان الموعد',
  iHaveRead: 'أقر بأني قرأت',
  termsAndConditions: 'الشروط والأحكام',
  confirmRequest: 'تأكيد الطلب',
  unAvailable: 'غير متوفر',
  edit: 'تعديل',
  requestSuccededPlaceholderTitle:
    'تم تقديم طلب حجز موعد زيارة مرفق عدلي بنجاح',
  requestSuccededPlaceholderText:
    'تم استقبال طلبك رقم {requestNumber} وسيتم اشعارك في حال تحديث حالة الطلب',
  autoAppointmentSuccessMsg:
    'تم حجز موعد زيارة مرفق عدلى بنجاح',
  requestInfo: 'تفاصيل الطلب',
  backToHome: 'العودة للرئيسية',
  viewRequestStatus: 'متابعة حالة الطلب',
  serviceType: 'نوع الخدمة',
  viewAppointmentTicket: 'استعراض تذكرة الموعد',
  day: 'اليوم',
  appointmentDate: 'تاريخ الموعد',
  appointmentDatePlaceholder: 'اختر تاريخ الموعد',
  appointmentTime: 'وقت الموعد',
  location: 'المكان',
  appointmentTicket: 'تذكرة الموعد',
  cancelAppointmentConfirmationTitle: 'هل أنت متأكد من إلغاء الموعد ؟ ',
  cancelAppointmentConfirmationDescription:
    'بتأكيد الإلغاء سيتم حذف الموعد نهائياً',
  backToRequests: 'العودة للطلبات',
  am: 'صباحاً',
  pm: 'مساءاً',
  amShort: 'ص',
  pmShort: 'م',
  hijriSuffix: 'هـ',
  meladiSuffix: 'م',
  importantInfo: 'معلومات هامة',
  canAddDateAndTimeFromMobileMsg:
    'عزيزي المستفيد، بإمكانك تحديد وقت وتاريخ الموعد عبر استخدام الخدمة في تطبيق ناجز للهواتف الذكية',

  requestNewAppointmentForm: {
    labels: {
      selectRegion: 'اختر المنطقة',
      selectSite: 'اختر مكان الموعد',
      selectDepartment: 'اختر القسم أو الدائرة',
      selectService: 'اختر الخدمة التي تريد حجز موعد لها',
    },
  },

  appointmentCardDetails: {
    cancelAppointmentTitle: 'إلغاء الموعد',
    cancelAppointmentText: 'هل انت متأكد من إلغاء الموعد؟',
    title: 'بطاقة موعد',
    id: 'رقم الموعد',
    active: 'ساري',
    inactive: 'غير ساري',
    service: 'الخدمة',
    siteName: 'المكان',
    socialId: 'رقم الهوية',
    fullName: 'المستفيد',
  },

  validationsMsgs: {
    fieldIsRequired: 'هذا الحقل مطلوب',
    onlyNumbers: 'الرجاء إدخال أرقام فقط',
    maxNumbersLength: 'أقصى عدد للأرقام هو {length}',
    maxCharsLength: 'أقصى عدد للمدخلات هو {length}',
    minNumbersLength: 'أقل عدد للأرقام هو {length}',
    minCharsLength: 'أقل عدد للمدخلات هو {length}',
    numbersExactLength: ' عدد المدخلات يجب أن يكون {length}',
    startsWith: ' يجب أن يبدأ ب {listText}',
  },

  months: {
    gregorian: {
      january: 'يناير',
      february: 'فبراير',
      march: 'مارس',
      april: 'أبريل',
      may: 'مايو',
      june: 'يونيو ',
      july: 'يوليو ',
      august: 'أغسطس',
      september: 'سبتمبر',
      october: 'أكتوبر',
      november: 'نوفمبر',
      december: 'ديسمبر',
    },
  },

  days: {
    Sunday: 'الأحد',
    Monday: 'الإثنين',
    Tuesday: 'الثلاثاء',
    Wednesday: 'الإربعاء',
    Thursday: 'الخميس',
    Friday: 'الجمعة',
    Saturday: 'السبت'
  },

  serverErrors: {
    NOT_FOUND: 'لا يمكننا خدمتك في الوقت الحالي.',
    SERVER_ERROR: 'حدث خطأ في النظام الرجاء المحاولة لاحقاً',
  },
};

export default ar;
